import syTable from './components/sy-table/index';
import syDialog from './components/sy-dialog/index';

const components = [
    syTable,
    syDialog
  ]

  const install = function (Vue, opts = {}) {
    components.map(component => {
      Vue.component(component.name, component);
    })
  }

  /* 支持使用标签的方式引入 */
  if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  export default {
    install,
    syTable,
    syDialog
  }


// WEBPACK FOOTER //
// ./src/index.js